import { NavMenu } from '../NavMenu'
import footerLogo from 'assets/FirstBite-Logo-Green.png'
import { FooterSignedInAs } from './FooterSignedInAs'

export default function Footer() {
  const supportEmail = 'support@firstbite.io'

  const handleEmailClick = () => {
    window.open(`mailto:${supportEmail}`)
  }

  return (
    <div className="bg-surface-sunken min-h-[var(--footer-height)] h-[var(--footer-height)] rounded-bl-lg rounded-br-lg">
      <div className="text-white flex items-center px-14 h-full max-[600px]:px-4 max-[600px]:justify-center">
        {/* Left Section - Signed in as */}
        <FooterSignedInAs />

        {/* Right Section - Links and Logo */}
        <div className="ml-auto flex items-center gap-3">
          <div className="bg-surface-sunken flex items-start">
            <NavMenu
              items={[
                {
                  label: 'Privacy Policy',
                  to: '/privacy-policy',
                },
                {
                  label: 'Terms of Use',
                  to: '/terms-of-use',
                },
                {
                  label: 'Contact Us',
                  to: '#',
                  onClick: handleEmailClick,
                },
              ]}
              options={{
                activeColor: '#04331D',
                textColor: '#18181B',
              }}
            />
          </div>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-surface-sunken flex h-10 items-center justify-center py-2 px-0">
              <img src={footerLogo} alt="First Bite" className="h-6 w-auto" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
